import ApiCalls from "../../config/apiCalls";
import Headers from "../../config/headers";


export default {
  namespaced: true,
  state: {
    isLoading: false,
    isMapScreenLoading: false,
  },
  getters: {
    getLoadingState: (state) => {
        return state.isLoading;
    }
  },
  mutations: {
    updateLoadingState(state, payload) {
      state.isLoading = payload;
    },
    updateMapScreenLoading(state, payload) {
      state.isMapScreenLoading = payload;
    }
  },
  actions: {
    
  },
};
